import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { speedTestAdsAuditDomainConfigEdit_template } from "../components/templates/speedTestAdsAuditDomainConfigEdit_template";

declare var ko: any;
declare var page: any;

export class speedTestAdsAuditDomainConfigEdit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected validationsList: validationsList_template;
    protected editForm: speedTestAdsAuditDomainConfigEdit_template;

    protected getModuleName(){

        return "speedTestAdsAuditDomainConfigEdit";
    }

    public buildContent(): Array<Element>{

        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the pageSpeed form
        this.editForm = new speedTestAdsAuditDomainConfigEdit_template("editForm", this.viewModel, this);

        return [this.editForm.build()];
    }

    public fillPage(): void{

        this.getFormData();
    }

    public getFormData(): void{

        let usrReq_url: string = '/api/speedTest/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormData;
        this.XHRHdl.execute();
    }

    protected onGetFormData(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.getEditData();
                }
            });
        }
    }

    protected getEditData(): void{

        let id = this.getVnAppZone().app.params.id || null;
        let idContentType = this.getVnAppZone().app.params.idContentType || null;

        if (id) {
            this.loadingIn(this.editForm.builtTemplate);

            let subViewModel = {
                idDomain: id,
                urlContentType: idContentType,
            };

            let usrReq_url: string = '/api/speedTest/configAdsAudit/get/' + id + '/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
            this.XHRHdl.execute();
        }
    }

    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                obj.editForm.setId(response.adsAuditDomain.id);
                obj.editForm.setDomainName(response.adsAuditDomain.domain);
                obj.editForm.setGroup(response.group);
                obj.editForm.setType(response.type);
                obj.editForm.setContentType(response.contentType);
                obj.editForm.setUrls(response.urls);
                obj.loadingOut(obj.editForm.builtTemplate);
            });
        }
    }

    protected getContentTypeUrls(): void{

        let id = this.getVnAppZone().app.params.id || null;

        if (id) {
            this.loadingIn(this.editForm.builtTemplate);

            let subViewModel = {
                idDomain: id,
                urlContentType: this.editForm.getTemplateViewModel().contentTypeField.selectedOption
            };

            let usrReq_url: string = '/api/speedTest/configAdsAudit/get/' + id + '/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetContentTypeUrls;
            this.XHRHdl.execute();
        }
    }

    protected onGetContentTypeUrls(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.editForm.setUrls(response.urls);
                obj.loadingOut(obj.editForm.builtTemplate);
            });
        }
    }

    protected updateFilters(responseParsed: any){

        this.editForm.setDomains(responseParsed.domains);
        this.editForm.setGroups(responseParsed.groups);
        this.editForm.setContentTypes(responseParsed.contentTypes);
        this.editForm.setTypes(responseParsed.types);
    }

    protected filterDropdownOnChange(idElement) {

        let id = this.getVnAppZone().app.params.id || null;

        if (id) {

            if (idElement == 'contentTypeField') {

                this.getContentTypeUrls();
            }
        }
    }

    protected cancel(){

        // Redirect to config list.
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Domain configuration action canceled !");

        page.redirect('/speed_test/config_ads_audit/');
    }

    protected save(): void{

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.editForm.getViewModelForRequest();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/speedTest/configAdsAudit/save', formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onSaveReturn;
        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Domain configuration saved successfully!');

                obj.validationsList.clearMessages();

                let response = JSON.parse(req.request.response);

                let id = response.idDomain;
                let idContentType = response.idContentType;

                page.redirect('/speed_test/config_ads_audit/edit/' + id + '/' + idContentType + '/');
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/speedTestAdsAuditDomainConfigEdit.ts